// Components==============
import React from 'react';
import './index.module.scss';
// =========================

export default function FluidGrid({
    items,
    component,
    isSchoolsTrainingPage,
    isNetworkPage,
}) {
    function getEmptyMessage() {
        if (isNetworkPage)
            return 'Er zijn geen geen netwerkbijeenkomsten gevonden';
        if (isSchoolsTrainingPage)
            return 'Er zijn geen opleidingen en trainingen gevonden';

        // Regular growth page
        return 'Er zijn geen opleidingen en trainingen gevonden met deze filters';
    }

    if (!items.length) return <h2>{getEmptyMessage()}</h2>;

    return (
        <div styleName={`wrapper ${isSchoolsTrainingPage ? 'school' : ''}`}>
            {items.map((item, i) => (
                <React.Fragment key={i}>
                    {React.cloneElement(component, {
                        ...item,
                    })}
                </React.Fragment>
            ))}
        </div>
    );
}
